<template>
  <li
    class="p-4 mb-3 flex justify-between items-center border border-light-grey rounded-lg cursor-move"
    style="background-color: #f8fafb"
  >
    <div class="flex items-center">
      <feather-icon icon="MenuIcon" svgClasses="h-3 w-3" class="mr-5 p-1"></feather-icon>
      <div class="relative">
        <feather-icon
          :icon="getFieldIcon(field)"
          svgClasses="h-4 w-4"
          class="p-2 inline-flex rounded-md bg-white border border-light-grey shadow"
        ></feather-icon>
        <div class="w-2 h-2 rounded-full bg-danger absolute top-0 right-0" v-if="field.isRequired"></div>
      </div>
      <div>
        <p class="ml-4 text-gray-700 font-semibold font-sans tracking-wide">
          {{ getFieldName(field) }}
        </p>
        <p class="ml-4 text-gray-600 font-sans tracking-wide">
          {{ field.label }}
        </p>
      </div>
      <!-- <p class="ml-4 text-gray-600 font-sans tracking-wide" v-if="field.helpText">
        · &nbsp; {{ field.helpText }}
      </p> -->
    </div>
    <div class="flex">
      <button
        aria-label="Edit field"
        class="action-button p-1 focus:outline-none focus:shadow-outline text-gray-600 hover:text-teal-600"
        @click="$emit('on-edit', field)"
      >
        <feather-icon icon="EditIcon" svgClasses="h-5 w-5" class="p-1 inline-flex"></feather-icon>
      </button>
    </div>
  </li>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      availableFields: "bookingForms/availableFields",
      getFieldIcon: "bookingForms/getFieldIcon",
      getFieldName: "bookingForms/getFieldName",
    }),
  },
};
</script>


<style scoped lang="css" src="@/assets/css/tailwind.min.css"></style>